import { assembleUrl } from '@/utils/url'

export default class EquivalentCourseGroupsService {
  constructor($axios, $store) {
    this.axios = $axios
    this.school = $store.state.settings.school
    this.equivalentCourseGroupsUrl = `/cm/${this.school}/equivalentCourseGroups`
  }

  getEquivalentCourseGroups({ list }) {
    const url = assembleUrl(this.equivalentCourseGroupsUrl, {
      list,
    })
    return this.axios.$get(url)
  }
}
